import src from "IMAGE";
export default { src, width: 942, height: 241, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAANUlEQVR42i3GIRIAEBQG4Xc3jmgoiqApCjOaC7jSb8ML386apICBjIqGhItlZOOhoGP6H8QPdBw5pbe7qIgAAAAASUVORK5CYII="};
